import React from 'react'

// core components
import AutoCompleteDropdown from 'components/CustomDropdown/AutoCompleteDropdown'

// Apollo thingy
import { graphql, Query } from 'react-apollo'

//wrapper specific, each dropdown needs a specific one
import { dictTypesOfApplication as dictData } from '../../queries/getDataForDropdowns'

// props here holds the classes and pass it down
const namePlaceholder = props => (
  <Query query={dictData} errorPolicy="all">
    {({ loading, error, data }) => {
      // console.log(data)
      if (error) return <p>Database connection error</p>
      if (loading) {
        return <p>Loading...</p>
      } else {
        const { helperText = 'Please choose an application...', labelText = '', ...rest } = props
        return (
          <AutoCompleteDropdown
            options={data.typesOfApplication.map(d => ({ ...d, label: d.name }))}
            placeholder={helperText}
            labelText={labelText}
            {...rest}
          />
        )
      }
    }}
  </Query>
)

export default graphql(dictData)(namePlaceholder)
